export const validateSelectedSizes = (selectedSizes) => {
    if (!selectedSizes.length) return true
    return !selectedSizes.some(size => isNaN(size.price) || size.price === null || size.price.trim() === '')
}